module.exports = __webpack_public_path__ + "media/src/images/checkbox__checkmark--dark-59869adaa5d33a638d40243f23864863.png";